var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('article',{staticClass:"logo"},[_c('a',[(_vm.webOrderShopImageUrl !== null)?_c('img',{staticClass:"logo-img",attrs:{"src":_vm.webOrderShopImageUrl}}):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51b2fb12","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Components/LogoHeader.vue
// module id = 453
// module chunks = 0